/**
 * RTK Query endpoints — Flows
 *
 * Migrated from: src/pages/flows/actions.js
 *
 * Pass the same `{ range, filters, sort }` params shape the legacy
 * `getFlows(params)` used so cache keys stay stable.
 *
 * `manageItemsFlow` invalidates that specific flow id so the see-flow
 * dialog refetches when items are added/removed.
 */

import { baseApi } from './baseApi';
import { buildQueryString } from './utils';

const flowApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    flowList: builder.query({
      query: (params = {}) => ({
        url: `/su/flows${buildQueryString(params)}`,
        method: 'GET',
      }),
      providesTags: (result) =>
        result?.items
          ? [
              ...result.items.map(({ id }) => ({ type: 'Flow', id })),
              { type: 'Flow', id: 'LIST' },
            ]
          : [{ type: 'Flow', id: 'LIST' }],
    }),

    createFlow: builder.mutation({
      query: (data) => ({
        url: '/su/flows',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [{ type: 'Flow', id: 'LIST' }],
    }),

    editFlow: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/su/flows/${id}/edit`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: 'Flow', id },
        { type: 'Flow', id: 'LIST' },
      ],
    }),

    deleteFlow: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/su/flows/${id}/delete`,
        method: 'DELETE',
        body: data,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: 'Flow', id },
        { type: 'Flow', id: 'LIST' },
      ],
    }),

    manageItemsFlow: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/su/flows/${id}/manage-items`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (_result, _error, { id }) => [{ type: 'Flow', id }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useFlowListQuery,
  useCreateFlowMutation,
  useEditFlowMutation,
  useDeleteFlowMutation,
  useManageItemsFlowMutation,
} = flowApi;

export default flowApi;
